import { Api } from "../axios-config/AxiosConfig";

export interface IEstablishment {
  id: string;
  nome: string;
  idComNome: string;
  numeroDoNivel: number;
  idEstabelecimento: string;
  idEstabelecimentoPai: string;
  idAlternativoDoEstabelecimento: string;
}

export interface IRespEstablishment {
  estabelecimentos: IEstablishment[];
  nivelDoEstabelecimentoQueIndicaMatricula: number;
}

export interface IUnityEstablishment {
  idEstabelecimento: string;
  nomeEstabelecimento: string;
  idConfiguracao: string | null;
  estabelecimentos: IUnityEstablishment[];
}

export interface IEstablishmentConfigFull {
  idEstabelecimento: string;
  nomeEstabelecimento: string;
  configuracao: IEstablishmentConfig | null;
}

export interface IEstablishmentConfig {
  id?: string;
  idEstabelecimento?: string;
  duracaoDoToken: number;
  instrucaoDeUsoDaAssinatura: string;
  termoDeAceite: {
    usaTermo: boolean;
    template: string;
  };
  emailDeVerificacao: {
    remetenteConta: string;
    assunto: string;
    template: string;
  };
}

const getEstablishments = async (): Promise<IRespEstablishment> => {
  try {
    const { data } = await Api().get<IRespEstablishment>(
      `/Estabelecimento/ListarEmCascata`
    );

    return data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

const getTreeEstablishments = async (): Promise<IUnityEstablishment[]> => {
  try {
    const { data } = await Api().get<IUnityEstablishment[]>(
      `/Configuracao/EstabelecimentosEmArvore`
    );

    return data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

const getEstablishmentConfigs = async (
  idEstabelecimento: string
): Promise<IEstablishmentConfigFull> => {
  try {
    const { data } = await Api().get<IEstablishmentConfigFull>(
      `/Configuracao/PorEstabelecimento/${idEstabelecimento}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

const postEstablishmentConfigs = async (
  payload: IEstablishmentConfig
): Promise<string> => {
  try {
    const { data } = await Api().post(`/Configuracao`, payload);

    return data.id;
  } catch (error: any) {
    throw new Error(`Erro ao salvar. ${error.mensagens}`);
  }
};

const putEstablishmentConfigs = async (
  id: string,
  payload: IEstablishmentConfig
): Promise<boolean> => {
  try {
    await Api().put(`/Configuracao/${id}`, payload);

    return true;
  } catch (error: any) {
    throw new Error(`Erro ao salvar. ${error.mensagens}`);
  }
};

const postReplicateConfigs = async (
  idConfiguracaoDeOrigem: string,
  idsEstabelecimentos: string[]
): Promise<boolean> => {
  try {
    await Api().post(
      `/Configuracao/Replicar/${idConfiguracaoDeOrigem}${idsEstabelecimentos
        .map((item, index) =>
          index === 0
            ? `?idsEstabelecimentos=${item}`
            : `&idsEstabelecimentos=${item}`
        )
        .join("")}`
    );

    return true;
  } catch (error: any) {
    throw new Error(`Erro ao salvar. ${error.mensagens}`);
  }
};

const deleteConfig = async (id: string): Promise<boolean> => {
  try {
    await Api().delete(`/Configuracao/${id}`);

    return true;
  } catch (error: any) {
    throw new Error(`Erro ao excluir. ${error.mensagens}`);
  }
};

export const EstablishmentService = {
  deleteConfig,
  getEstablishments,
  postReplicateConfigs,
  getTreeEstablishments,
  getEstablishmentConfigs,
  putEstablishmentConfigs,
  postEstablishmentConfigs,
};
